export function generateKeys(fields: Record<string, string>) {
  const keys: Record<string, string> = {};
  for (const key in fields) {
    keys[key] = `${key}-${Date.now()}`;
  }
  return keys;
}
